export default "__VITE_ASSET__iL6SzpYU__"